import Education from './Education.vue';

export default Education;



// WEBPACK FOOTER //
// ./src/pages/profile/views/education/index.ts